import VueI18n from "vue-i18n";
import Vue from "vue";
import VueRouter from "vue-router";
import {createPinia} from "pinia";

const pinia = createPinia()

Vue.use(pinia)
if (!Object.prototype.hasOwnProperty.call(Vue.prototype, '$router')) {
  Vue.use(VueRouter);
}

export default {
  mountComponent(selector, component, router) {
    const elements = document.querySelectorAll(selector);
    const messages = {}
    messages[window.languageCode] = window.locales;
    if (!router) {
      router = new VueRouter({mode: 'history'})
    }

    elements.forEach(function (el) {
      if (el.__vue__) {
        return;
      }
      const props = JSON.parse(el.getAttribute('data'));
      const i18n = new VueI18n({
        locale: window.languageCode,
        messages
      });

      let vue = new Vue({
        pinia,
        i18n,
        el,
        render: h => h(component, {
          props
        }),
        router: router
      });
    });
  },
  setupMoment(moment) {
    moment.locale(window.languageCode)
    moment.tz.setDefault(window.timeZone)
  },
  setupAxios(axios) {
    if (!axios || !axios.defaults || !axios.defaults.headers) {
      console.error('Axios is not properly initialized');
      return;
    }
    
    axios.defaults.headers.common['Accept'] = 'application/json';

    const csrfToken = document.querySelector("meta[name=csrf-token]");
    if (csrfToken) {
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken.content;
    }
  },
}
